export const ResendWebhookIcon = () => (
	<svg
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clipPath='url(#clip0_8517_60453)'>
			<path
				d='M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z'
				fill='url(#paint0_linear_8517_60453)'
			/>
			<path
				d='M58.9239 37.2559L58.9194 37.248C57.6338 35.0322 56.5236 33.1186 56.5236 28.9862V27.6094C56.5236 26.0884 55.2906 24.8555 53.7697 24.8555C52.2488 24.8555 51.0156 26.0884 51.0156 27.6094V28.9862C51.0156 34.5419 52.6659 37.4373 54.1244 39.9964L54.1278 40.0023C55.4133 42.218 56.5234 44.1316 56.5234 48.2636V51.2011C56.5234 54.9973 53.435 58.0858 49.6387 58.0858C45.8425 58.0858 42.7541 54.9972 42.7541 51.2011V28.9862C42.7541 22.153 37.1948 16.5938 30.3616 16.5938C23.5283 16.5938 17.9688 22.153 17.9688 28.9862V31.9237C17.9688 37.4794 19.6191 40.3748 21.0775 42.9339L21.0809 42.9398C22.3664 45.1555 23.4766 47.0691 23.4766 51.2011V52.578C23.4766 54.0989 24.7095 55.3319 26.2305 55.3319C27.7514 55.3319 28.9844 54.0991 28.9844 52.5781V51.1094H28.9836C28.9653 45.6142 27.3261 42.7359 25.877 40.1934L25.8725 40.1855C24.5869 37.9697 23.4767 36.0561 23.4767 31.9237V28.9862C23.4767 25.19 26.5652 22.1016 30.3614 22.1016C34.1577 22.1016 37.2461 25.19 37.2461 28.9862V51.2011C37.2461 58.0344 42.8053 63.5936 49.6386 63.5936C56.4719 63.5936 62.0312 58.0345 62.0312 51.2012V48.2638C62.0312 42.708 60.3811 39.8127 58.9239 37.2559ZM24.8534 57.9117V62.2169C24.8534 62.9773 25.47 63.5938 26.2303 63.5938C26.9906 63.5938 27.6072 62.9772 27.6072 62.2169V57.9117C27.1669 58.0255 26.7055 58.0859 26.2303 58.0859C25.7552 58.0859 25.2937 58.0253 24.8534 57.9117ZM55.1466 22.2758V17.9706C55.1466 17.2102 54.53 16.5938 53.7697 16.5938C53.0094 16.5938 52.3928 17.2103 52.3928 17.9706V22.2758C52.8331 22.162 53.2945 22.1016 53.7697 22.1016C54.2448 22.1016 54.7062 22.162 55.1466 22.2758Z'
				fill='url(#paint1_linear_8517_60453)'
			/>
		</g>
		<defs>
			<linearGradient
				id='paint0_linear_8517_60453'
				x1='40'
				y1='80'
				x2='40'
				y2='0'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#ADDCFF' />
				<stop
					offset='0.5028'
					stopColor='#EAF6FF'
				/>
				<stop
					offset='1'
					stopColor='#EAF6FF'
				/>
			</linearGradient>
			<linearGradient
				id='paint1_linear_8517_60453'
				x1='40'
				y1='63.5938'
				x2='40'
				y2='16.5938'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C0FF' />
				<stop
					offset='1'
					stopColor='#5558FF'
				/>
			</linearGradient>
			<clipPath id='clip0_8517_60453'>
				<rect
					width='80'
					height='80'
					fill='white'
				/>
			</clipPath>
		</defs>
	</svg>
);
